import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import MDEditor from '@uiw/react-md-editor';
import { getInterviewById, updateInterviewView } from '../../../service/interview';
import type { InterviewPost } from '@/types';
import './index.scss';

const ArticleDetail: React.FC = () => {
  const { postsId } = useParams<{ postsId: string }>();
  const navigate = useNavigate();
  const [article, setArticle] = useState<InterviewPost | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!postsId) return;

    setLoading(true);
    getInterviewById(Number(postsId))
      .then((res) => {
        if (res.success && res.data) {
          setArticle(res.data);
        }
      })
      .catch(() => {
        navigate('/interview-question', { replace: true });
      })
      .finally(() => {
        setLoading(false);
      });

    // 记录浏览次数
    updateInterviewView(Number(postsId));
  }, [postsId, navigate]);

  if (loading) {
    return (
      <div className="article-detail-container">
        <div className="article-loading">加载中...</div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="article-detail-container">
        <div className="article-error">文章不存在</div>
      </div>
    );
  }

  return (
    <div className="article-detail-container">
      <Link to="/interview-question" className="article-back">← 返回面试问题列表</Link>

      <div className="article-detail">
        <div className="article-header">
          <h1 className="article-title">{article.title}</h1>
          <div className="article-meta">
            <span className="article-date">{article.updated_at}</span>
            <span className="article-separator">|</span>
            <span className="article-views">👁 {article.view_count} 次浏览</span>
          </div>
        </div>
        <div className="article-divider" />

        <div className="article-content" data-color-mode="dark">
          <MDEditor.Markdown style={{backgroundColor:'transparent'}} source={article.content} />
        </div>
      </div>
    </div>
  );
};

export default ArticleDetail;
